import { apiProxyRequest } from "Api/apiProxyRequest";

import type { AccountsProfile } from "./types";

export const updateProfileRequest = (
  userId: string,
  profileData: Partial<AccountsProfile>
) =>
  apiProxyRequest<AccountsProfile>(`/profiles/${userId}`, "PATCH", profileData);
